export default __webpack_public_path__ + "static/media/hus_1.b230d125.svg";